import { Box } from '@mui/material'
import React from 'react'

const MaContainer = ({children}) => {
  return (
  <Box sx={{m:'0 auto', width:{xl:"75%", lg:'85%', md:'85%', sm:'90%', xs:'95%'}}}>
{children}
  </Box>
  )
}

export default MaContainer
